import React from 'react';
import { UserFreebet } from '../../../../models';
import { useStore, useTranslation } from '../../../../hooks';
import { T } from '../../../../constants';
import './style.scss';
import { formatDate, formatValue } from '../../../../helpers';

interface FreeSpinHeaderProps {
  data: UserFreebet;
}

const FreeSpinHeader = ({ data }: FreeSpinHeaderProps) => {
  const translate = useTranslation();
  const { gameStore } = useStore();
  const { currencySymbol } = gameStore;
  return (
    <div className="FreeSpin-head">
      <p className="FreeSpin-head-text">
        {translate(T.CONGRATULATIONS_YOUVE_WON_FREE_SPINS)}
      </p>
      <p className="FreeSpin-head-sub-text">
        {data.remainingCount || data.count} {translate(T.FREE_SPINS)}
      </p>
      <p className="head-amount-text">
        {translate(T.SPIN_AMOUNT)}
      </p>
      <span className="head-amount-num">
        {data.amount} {currencySymbol}
      </span>
      <div className="amount-used-text-wrp">
        <p className="head-amount-used-text">
          {translate(T.CAN_BE_USED_UNTIL)}:
          <span className="head-amount-used-num">
            {formatDate(new Date(data.expireDate))}
          </span>
        </p>
        <div className="amount-used-bottom-row">
          {
            data.minOdd ? (
              <p className="head-amount-used-text">
                {translate(T.MIN_ODD)}:
                <span className="head-amount-used-num">
                  {formatValue(data.minOdd)}
                </span>
              </p>
            ) : null
          }
          {
            data.maxPayout ? (
              <p className="head-amount-used-text">
                {translate(T.MAX_PAYOUT)}:
                <span className="head-amount-used-num">
                  {formatValue(data.maxPayout)}
                </span>
              </p>
            ) : null
          }
        </div>
      </div>
    </div>
  );
};

export default FreeSpinHeader;
